import KpiCard from '../common/KpiCard';
import useMetric from '../../hooks/useMetric';
import { changePct, formatNumber } from '../../utils/format';

export default function VisitorKpiCard() {
  const { status, data, error, retry } = useMetric('visitors');
  return (
    <KpiCard
      testId="kpi-visitors" title="Total Visitors" icon="bi-eye" tone="info" to="/analytics"
      status={status} error={error} onRetry={retry} emptyText="No visitors yet."
      value={data && formatNumber(data.value)} delta={data && changePct(data.value, data.previous)}
      sparkline={data?.sparkline} footnote="Unique website and chat visitors"
    />
  );
}
